{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/social-link",
	"title": "Social Icon",
	"category": "widgets",
	"parent": [ "core/social-links" ],
	"description": "Display an icon linking to a social profile or site.",
	"textdomain": "default",
	"attributes": {
		"url": {
			"type": "string",
			"role": "content"
		},
		"service": {
			"type": "string"
		},
		"label": {
			"type": "string",
			"role": "content"
		},
		"rel": {
			"type": "string"
		}
	},
	"usesContext": [
		"openInNewTab",
		"showLabels",
		"iconColor",
		"iconColorValue",
		"iconBackgroundColor",
		"iconBackgroundColorValue"
	],
	"supports": {
		"reusable": false,
		"html": false,
		"interactivity": {
			"clientNavigation": true
		}
	},
	"editorStyle": "wp-block-social-link-editor"
}
